export interface PersonaDeudaDTO {
  numeroidentificacion: string;
  idpersona: number;
  nombrecompleto: string;
  email: string;
}

export interface ObligacionDTO {
  iddecinvobligacion: number;
  idpersona: number;
  nombreInvestigador: string;
  nombreUnidad: string;
  idcustodio: number;
  nombreCustodio: string;
  iddecinvtipoobligacion: number;
  nombreTipoObligacion: string;
  estado: string;
  textoEstado: string;
  fechalimite: Date;
  fechaliberacion: Date;
  idliberador: number;
  nombreLiberador: string;
  fecharegistro: Date;
  infoobligaciondtos: InfoObligacionDTO[];
}

export function VoidObligacionDTO(): ObligacionDTO {
  return {
    iddecinvobligacion: 0,
    idpersona: 0,
    nombreInvestigador: '',
    nombreUnidad: '',
    idcustodio: 0,
    nombreCustodio: '',
    iddecinvtipoobligacion: 0,
    nombreTipoObligacion: '',
    estado: '',
    textoEstado: '',
    fechalimite: new Date(),
    fechaliberacion: new Date(),
    idliberador: 0,
    nombreLiberador: '',
    fecharegistro: new Date(),
    infoobligaciondtos: []
  };
}

export interface InfoObligacionDTO {
  iddecinvinfoobligacion: number;
  archivocontenido: string | null;
  refarchivo: string;
  descripcion: string;
  detalle: string;
  obligatorio: string;
  textoObligatorio: string;
}

export function VoidInfoObligacionDTO(): InfoObligacionDTO {
  return {
    iddecinvinfoobligacion: 0,
    archivocontenido: '',
    refarchivo: '',
    descripcion: '',
    detalle: '',
    obligatorio: '',
    textoObligatorio: '',
  }
}

export interface TipoObligacionDTO {
  iddecinvtipoobligacion: number;
  codigo: string;
  nombre: string;
  descripcion: string;
}

export interface ObligacionForm {
  idInvObligacion: number,
  idpersona: number,
  idInvTipoObligacion: number,
  fechaIngreso: Date,
  fechaLimite: Date,
  estado: string,
  numeroidentificacion: string,
  nombrecompleto: string,
  email: string,
  archivos: InfoObligacionDTO[],
  iddecinvinfoobligacionDocPago: number,
  selectDocpago: boolean,
  docpago: any,
  docpagoDescp: string,
  iddecinvinfoobligacionCertpart: number,
  selectCertpart: boolean,
  certpart: any,
  certpartDescp: string,
  iddecinvinfoobligacionArtcient: number,
  selectArtcient: boolean,
  artcient: any,
  artcientDescp: string,
}